const API_KEY = "f1d2748c024dde4cf19a42f2f02bf23c";
export default API_KEY;
